import React from 'react';
import { Experience } from '../types';
import './ExperienceTimeline.css';

interface ExperienceTimelineProps {
  experiences: Experience[];
}

const ExperienceTimeline: React.FC<ExperienceTimelineProps> = ({ experiences }) => {
  return (
    <div className="timeline-hypercontainer">
      <div className="timeline-container">
        {experiences.map((experience) => (
          <div key={`${experience.id}-${experience.title}`} className="timeline-item">
            <h2>{experience.title}</h2>
            <p>{experience.company}</p>
            <p>{experience.duration}</p>
            {experience.description && <p>{experience.description}</p>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExperienceTimeline; 